import type { ReactNode } from "react"

import { useParams } from "react-router-dom"

import useSolarProposal from "~/api/hooks/useSolarProposal"

import { isSolarSummaryRequired } from "./solar-summary-steps"
import { SolarSummaryRedirect } from "./SolarSummaryRedirect"
import { SolarProposalLoadState } from "../solar-proposal-load-state"

/**
 * The Summary gate for a route outside the shell (the full-screen designer):
 * an editor of an unconfirmed proposal goes to the Summary first. It waits for
 * the header read rather than guess, and a failed read offers a retry.
 */
export const SolarSummaryGate = ({
  children,
}: {
  children: ReactNode
}): JSX.Element => {
  const { proposalId = `` } = useParams<{ proposalId: string }>()
  const query = useSolarProposal(proposalId)

  if (!query.data) {
    return <SolarProposalLoadState query={query} />
  }

  if (isSolarSummaryRequired(query.data)) {
    return <SolarSummaryRedirect proposalId={proposalId} />
  }

  return <>{children}</>
}
